import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { DashboardService } from './../../dashboard.service'
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { AdminLanguageService } from '../../services/admin-language-service/admin-language.service';
import { Trainer } from 'src/app/models/trainer.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import {LocalStorageService} from '../../services/localStorage-service/local-storage.service';
import {Training} from '../../../models/training.model';



@Component({
    selector: 'app-insert-trainings-to-folder-dialog',
    templateUrl: './insert-trainings-dialog.component.html',
    styleUrls: ['./insert-trainings-dialog.component.scss'],
    standalone: false
})
export class InsertTrainingsDialogComponent implements OnInit {
  err: boolean = false;
  @ViewChild('insertForm') insertForm: NgForm

  labels;
  labelsSub: Subscription;
  selectedImage: File = null
  trainings: Training[]
  duration: Number = 0
  uploading: boolean = false
  assignedTrainings
  constructor(private router: Router, public snackBar: MatSnackBar, public dialogRef: MatDialogRef<InsertTrainingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data, private dashboardService: DashboardService, private localStorageService: LocalStorageService, public adminLanguageService: AdminLanguageService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.err = false;
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
    this.assignedTrainings = this.data.assignedTrainings ?? []
    this.dashboardService.getTrainings().subscribe((trainings)=> {
      this.trainings = trainings as Training[]
    })
  }

  isChecked(trainingId) {
    return this.assignedTrainings?.find(training => training == trainingId) ?? false
  }

  addTraining(checked, trainingId) {
    if (checked) {
      this.assignedTrainings.push(trainingId)
    } else {
      this.assignedTrainings = this.assignedTrainings.filter(training => training != trainingId)
    }
  }

   onSubmit() {
    let data = {
      content: this.assignedTrainings,
      folderId: this.data.folderId
    }
      this.dashboardService.modifyFolderContent(data).subscribe((response) => {
        this.dialogRef.close()
      })
  }
  onNoClick() {
    this.dialogRef.close()
  }

}
